import { KoobInputDate } from '../../components';
import { parseDateOnly } from '@koob/dates';
import { SubLabel } from './SubLabel';
import type { ChildrenAgesFieldProps } from './types';

export type { ChildrenAgesFieldProps };

export function ChildrenAgesField({
  birthdates,
  onBirthdateChange,
  t,
}: ChildrenAgesFieldProps) {
  if (birthdates.length === 0) return null;

  return (
    <div className="mt-6">
      <SubLabel>{t('travellers.birthdates')}</SubLabel>
      <div className="mt-2 grid grid-cols-1 gap-3 sm:grid-cols-2">
        {birthdates.map((b, i) => (
          <div key={i} className="flex items-center gap-3">
            <span className="w-16 shrink-0 text-sm text-gray-500">
              {t('travellers.child', { index: i + 1 })}
            </span>
            <KoobInputDate
              value={typeof b === 'string' ? (b ? parseDateOnly(b) : null) : b}
              onChange={(d) => onBirthdateChange(i, d)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
